const maskCellphone = value => {
  if (!value) return { maskedCellPhone: '', unmaskedCellPhone: '' }

  const unmaskedCellPhone = value.replace(/\D/g, '')
  const directDistanceDialingMasked = unmaskedCellPhone.replace(/^(\d{2})(\d{1})/g, '($1) $2')
  const cellPhoneMasked = directDistanceDialingMasked.replace(/(\d{5})(\d{1})/, '$1-$2')
  return { maskedCellPhone: cellPhoneMasked.substring(0, 15), unmaskedCellPhone }
}

const maskPhone = value => {
  if (!value) return { maskedPhone: '', unmaskedPhone: '' }

  const unmaskedPhone = value.replace(/\D/g, '')
  const directDistanceDialingMasked = unmaskedPhone.replace(/^(\d{2})(\d{1})/g, '($1) $2')
  const maskedPhone = directDistanceDialingMasked.replace(/(\d{4})(\d{1})/, '$1-$2')
  return { maskedPhone: maskedPhone.substring(0, 14), unmaskedPhone }
}

export { maskCellphone, maskPhone }
